import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { AddeditMarketComponent } from '../addedit-market/addedit-market.component';



@Component({
  selector: 'app-market-dialog',
  standalone:true,
  imports: [FormsModule,CommonModule,AddeditMarketComponent,MatButtonModule],
  templateUrl: './market-dialog.component.html',
  styleUrls: ['./market-dialog.component.scss'],
})
export class MarketmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<MarketmDialogComponent, any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
   
  }
  marketFormData:any;
  ngOnInit( ){
    if(!this.data || !this.data?.formData) {

    }
  }
  onNoClick(): void {
    this.dialogRef.close({ submitted: false });
  }

  onSaveClick(): void {
      this.dialogRef.close({ submitted: true, data: this.marketFormData});
  }
  onFormSubmit(data :any) {
    if(data.submit == false) {
      this.dialogRef.close({ submitted: false});
    }else {
      this.marketFormData = data;
      this.onSaveClick();
      console.log("onFormSubmit",data)
    }
   
  }
}